export default __webpack_public_path__ + "static/media/image 13.a6836e1d.svg";